import { ArrowsLeftRight, ClockCounterClockwise, Receipt, Wallet } from '@phosphor-icons/react';
import { useT } from '../lib/i18n';
import { switchTab } from '../lib/router';
import { haptic } from '../lib/telegram';

export type Tab = 'wallet' | 'swap' | 'pay' | 'history';

const TABS: Array<{ id: Tab; path: string; Icon: typeof Wallet }> = [
  { id: 'wallet', path: '/', Icon: Wallet },
  { id: 'swap', path: '/swap', Icon: ArrowsLeftRight },
  { id: 'pay', path: '/pay', Icon: Receipt },
  { id: 'history', path: '/history', Icon: ClockCounterClockwise },
];

export function TabBar({ active }: { active: Tab }) {
  const t = useT();
  return (
    <nav className="tabbar" aria-label="Main">
      {TABS.map(({ id, path, Icon }) => (
        <button
          key={id}
          type="button"
          className={`tabbar__item${active === id ? ' is-active' : ''}`}
          aria-current={active === id ? 'page' : undefined}
          onClick={() => {
            if (active !== id) haptic.select();
            switchTab(path);
          }}
        >
          <Icon size={24} weight="fill" aria-hidden="true" />
          <span>{t[`tab.${id}`]}</span>
        </button>
      ))}
    </nav>
  );
}
